/* up-sell-product.js — 提取公共逻辑，消除重复 */

function updateVariantUI(select) {
  const selectedOption = select.options[select.selectedIndex];
  if (!selectedOption) return;

  const itemRow = select.closest('.up-sell-product__item');
  if (!itemRow) return;

  // Update product image
  const newImage = selectedOption.dataset.image;
  const productImage = itemRow.querySelector('[data-up-sell-image]');
  if (newImage && productImage) {
    productImage.src = newImage;
  }

  // Update price
  const newPrice = selectedOption.dataset.price;
  const newCompareAtPrice = selectedOption.dataset.compareAtPrice;
  const priceContainer = itemRow.querySelector('.up-sell-product__price');
  if (newPrice && priceContainer) {
    let priceHTML = '<div class="price">';
    if (newCompareAtPrice) {
      priceHTML += `
        <div class="price__sale">
          <span class="visually-hidden visually-hidden--inline">Regular price</span>
          <span><s class="price-item price-item--regular">${newCompareAtPrice}</s></span>
          <span class="visually-hidden visually-hidden--inline">Sale price</span>
          <span class="price-item price-item--sale price-item--last">${newPrice}</span>
        </div>`;
    } else {
      priceHTML += `
        <div class="price__regular">
          <span class="visually-hidden visually-hidden--inline">Regular price</span>
          <span class="price-item price-item--regular">${newPrice}</span>
        </div>`;
    }
    priceHTML += '</div>';
    priceContainer.innerHTML = priceHTML;
  }

  // Sync the form's hidden [name=id] input so product-form.js can read it
  const form = itemRow.querySelector('form');
  if (form) {
    const hiddenIdInput = form.querySelector('input[type="hidden"][name="id"]');
    if (hiddenIdInput) {
      hiddenIdInput.value = selectedOption.value;
    }
  }

  // Update button state
  const isAvailable = selectedOption.dataset.available === 'true';
  const addToCartButton = itemRow.querySelector('.up-sell-product__add-to-cart');
  const buttonText = addToCartButton?.querySelector('span');
  if (addToCartButton) {
    if (isAvailable) {
      addToCartButton.removeAttribute('disabled');
      if (buttonText) {
        buttonText.textContent = window.variantStrings
          ? window.variantStrings.addToCart
          : 'Add to cart';
      }
    } else {
      addToCartButton.setAttribute('disabled', 'disabled');
      if (buttonText) {
        buttonText.textContent = window.variantStrings
          ? window.variantStrings.soldOut
          : 'Sold out';
      }
    }
  }
}

/* Web Component：通过 <up-sell-product> 包裹时自动绑定 */
class UpSellProduct extends HTMLElement {
  constructor() {
    super();
    this.variantSelects = this.querySelectorAll('.up-sell-variant-select');
    if (this.variantSelects.length) {
      this.variantSelects.forEach((select) => {
        select.addEventListener('change', () => updateVariantUI(select));
      });
    }
  }
}

if (!customElements.get('up-sell-product')) {
  customElements.define('up-sell-product', UpSellProduct);
}

/* Fallback：未使用 <up-sell-product> 包裹时，通过事件委托绑定 */
document.addEventListener('change', function (event) {
  const select = event.target;
  if (!select.classList.contains('up-sell-variant-select')) return;

  // 避免与 Web Component 重复触发
  if (select.closest('up-sell-product')) return;

  updateVariantUI(select);
});
